export function downscaleImage(file, max = 1000, quality = 0.82) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        let w = img.width, h = img.height;
        if (Math.max(w, h) > max) { const s = max / Math.max(w, h); w = Math.round(w * s); h = Math.round(h * s); }
        const c = document.createElement("canvas");
        c.width = w; c.height = h;
        c.getContext("2d").drawImage(img, 0, 0, w, h);
        resolve(c.toDataURL("image/jpeg", quality));
      };
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export function fileToDataUrl(file) {
  return new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.onerror = rej;
    r.readAsDataURL(file);
  });
}

// Banner ko upload ke time hi 1200x630 (OG standard) pe cover-crop kar deta hai —
// isse link preview, home page, form, pass sab jagah same size dikhta hai.
export function resizeBannerToOg(file, w = 1200, h = 630, quality = 0.85) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const scale = Math.max(w / img.width, h / img.height);
        const sw = w / scale, sh = h / scale;
        const sx = (img.width - sw) / 2, sy = (img.height - sh) / 2;
        const c = document.createElement("canvas");
        c.width = w; c.height = h;
        c.getContext("2d").drawImage(img, sx, sy, sw, sh, 0, 0, w, h);
        resolve(c.toDataURL("image/jpeg", quality));
      };
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export const FIELD_TYPES = [
  { value: "text", label: "Text" },
  { value: "longtext", label: "Long Text" },
  { value: "number", label: "Number" },
  { value: "date", label: "Date" },
  { value: "time", label: "Time" },
  { value: "dropdown", label: "Dropdown" },
  { value: "checkbox", label: "Tick / Checkbox" },
  { value: "photo", label: "Photo" },
];

// ver (event.updated_at) link me cache-buster ke roop me jata hai taaki banner badalne par WhatsApp naya preview scrape kare
const _ver = (ver) => String(ver || "").replace(/[^A-Za-z0-9]/g, "").slice(0, 14);

export const eventShareUrl = (token, ver) => `${window.location.origin}/api/event/link/${token}${ver ? `?v=${_ver(ver)}` : ""}`;

export const passShareUrl = (token, ver) => `${window.location.origin}/api/pass/link/${token}${ver ? `?v=${_ver(ver)}` : ""}`;

export const masterShareUrl = (token) => `${window.location.origin}/#/master/${token}`;

export const scannerShareUrl = (token) => `${window.location.origin}/#/scan/${token}`;

// QR par encode hone wala payload — URL nahi, opaque token. Isse Google Lens / PhonePe / normal QR apps
// ise na link, na payment samajhte hain; sirf app ka apna scanner ise decode kar pata hai.
export const passQrPayload = (token) => `SOOTRIK-PASS:${token}`;

export const passTokenFromText = (text) => {
  const t = String(text).trim();
  const pfx = t.match(/^SOOTRIK-PASS:([a-f0-9]{16,})$/i);
  if (pfx) return pfx[1];
  const m = t.match(/(?:#\/pass\/|pass\/link\/|\/pass\/)([A-Za-z0-9-]{8,})/);
  if (m) return m[1];
  const bare = t.match(/^([a-f0-9]{16,})$/i);
  return bare ? bare[1] : null;
};

function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

// Registers SW, asks permission, subscribes to push and sends it to backend.
// Returns true on success. Throws with a friendly message on failure.
export async function enablePushForMobile(API, token, submissionId) {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    throw new Error("Is browser me notification support nahi hai");
  }
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notification permission nahi mili");
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const { data } = await fetch(`${API}/public/vapid`).then((r) => r.json()).then((d) => ({ data: d }));
  const key = data.publicKey;
  if (!key) throw new Error("Push key unavailable");
  let subscription = await reg.pushManager.getSubscription();
  if (!subscription) {
    subscription = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(key),
    });
  }
  const res = await fetch(`${API}/public/event/${token}/subscribe`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ submission_id: submissionId, subscription: subscription.toJSON() }),
  });
  if (!res.ok) throw new Error("Subscribe failed");
  return true;
}
